// @flow

import React, {Component} from 'react'
import xml2js from 'xml2js'
import {observer} from 'mobx-react'

import api from '../../../src/api/client'
import {getMedicineInfoDetailsFromJson} from '../helpers'
import store from '../store'

import css from './MedicineInfoAdder.css'

class DragDropFile extends Component {
  suppress(evt) {
    evt.stopPropagation()
    evt.preventDefault()
  }

  onDrop = (evt) => {
    evt.stopPropagation()
    evt.preventDefault()
    const files = evt.dataTransfer.files

	  if(files && files[0]) {
      this.props.handleFile(files[0])
    }
  }

  render() {
    return (
      <div
        onDrop={this.onDrop}
        onDragEnter={this.suppress}
        onDragOver={this.suppress}>
	      {this.props.children}
      </div>
    )
  }
}

type DataInputProps = {
  id: string,
  fileName: string,
  handleFile: Function,
}
class DataInput extends Component {
  props: DataInputProps

  handleChange = (e) => {
	  const files = e.target.files
    if(files && files[0]) {
      this.props.handleFile(files[0])
    }
  }
  render() {
    const {fileName, id} = this.props
    return (
      <div className={css.fileInputWrapper}>
        <div>
          <label htmlFor={id} className={css.fileLabel}>Valitse tiedosto</label>
          <input
            type="file"
            accept="text/xml"
            className={css.fileInput}
            id={id}
            onChange={this.handleChange} />
        </div>
        <div>
          <p className={css.fileName}>{fileName}</p>
        </div>
      </div>
	   )
  }
}
type State = {
  fileName: string,
  hasMedicineInfosUpdated: boolean,
  isUpdating: boolean,

}
@observer
class MedicineInfoAdder extends Component {
  state: State = {
    fileName: '',
    hasMedicineInfosUpdated: false,
    isUpdating: false,
  }

  handleFile = (file: any) => {
    const parser = new xml2js.Parser()

    const reader:any = new FileReader()
    reader.onload = (e) => {
      parser.parseString(e.target.result, function (err, result) {
        const medicineInfos = getMedicineInfoDetailsFromJson(result)
        store.saveNewMedicineInfos(medicineInfos)
        console.log('Done')
      })
    }
    reader.readAsBinaryString(file)

    this.setState({
      fileName: file.name,
    })
  }

  updateMedicineInfos = async() => {
    this.setState({isUpdating: true})
    try {
      const newMedicineInfos = store.newMedicineInfos
      const response = await api.resources.medicineinfo.updateMedicineInfos(newMedicineInfos)
      if(response) {
        this.setState({hasMedicineInfosUpdated: true, isUpdating: false})
        store.saveNewMedicineInfos([])
      }
    } catch(e) {
      this.setState({isUpdating: false})
      console.log(e)
    }
  }


  render() {
    const {fileName, hasMedicineInfosUpdated, isUpdating} = this.state
    const newMedicineInfos = store.newMedicineInfos

    return (
      <div className={css.component}>
        <DragDropFile handleFile={this.handleFile}>
          <DataInput id="file_xml" handleFile={this.handleFile} fileName={fileName} />
        </DragDropFile>
        {newMedicineInfos.length > 0 && (
          <button className={css.button} disabled={isUpdating} type='button' onClick={() => this.updateMedicineInfos()} >{isUpdating ? 'Päivitetään...' : 'Päivitä lääkeoppaan data'}</button>
        )}
        {hasMedicineInfosUpdated && (
          <p className={css.hasUpdated}>Data on päivitetty</p>
        )}

      </div>
    )
  }
}

export default MedicineInfoAdder



// WEBPACK FOOTER //
// ./src/admin/components/MedicineInfoAdder.js